import { createReducer, on } from '@ngrx/store';
import { CategoryAirplaySecurityProfilePresetConfigurationApiActions } from './category-airplay-security-profile-preset-configuration.actions';
import { adapter, initialState, selectId } from './category-airplay-security-profile-preset-configuration.state';

export const categoryAirplaySecurityProfilePresetConfigurationReducer = createReducer(
  initialState,
  on(
    CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationLoaded,
    CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationAdded,
    (state, { configuration }) => {
      return adapter.upsertOne(configuration, state);
    }
  ),
  on(
    CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationUpdated,
    (state, { configuration }) => {
      return adapter.updateOne(
        {
          id: selectId(configuration),
          changes: configuration,
        },
        state
      );
    }
  ),
  on(
    CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationDeleted,
    (state, { configuration }) => {
      return adapter.removeOne(selectId(configuration), state);
    }
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryAirplaySecurityProfilePresetConfigurationIds = selectIds;
export const selectCategoryAirplaySecurityProfilePresetConfigurationEntities = selectEntities;
export const selectAllCategoryAirplaySecurityProfilePresetConfigurations = selectAll;
